/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var MinusCircleIcon = createIcon("MinusCircleIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M9 18A9 9 0 109 0a9 9 0 000 18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17A8 8 0 109 1a8 8 0 000 16Zm0 1A9 9 0 119 0a9 9 0 010 18Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.013h7.5",
    stroke: "#171717",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {});